import React from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "../button";

interface FormHeaderProps {
    onBack: () => void;
    title?: string;
    titleIcon?: React.ReactNode;
    subtitle?: string;
    backLabel?: React.ReactNode;
    backIcon?: React.ReactNode;
    actions?: React.ReactNode;
    className?: string;
}

const DEFAULT_TITLE = "Create New Survey";
const DEFAULT_SUBTITLE = "Design your survey with a Google Form-like interface";

export function FormHeader({
    onBack,
    title = DEFAULT_TITLE,
    titleIcon,
    subtitle = DEFAULT_SUBTITLE,
    backLabel = "Back",
    backIcon = <ArrowLeft className="h-4 w-4" />,
    actions,
    className = "",
}: FormHeaderProps) {
    return (
        <div
            className={`sticky top-0 z-30 bg-white/95 dark:bg-gray-800/95 backdrop-blur border-b border-gray-200 dark:border-gray-700 py-4 ${className}`.trim()}
        >
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-4 pl-4">
                    <Button
                        variant="outline"
                        onClick={onBack}
                        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-gray-100"
                    >
                        {backIcon}
                        {backLabel}
                    </Button>
                    <div>
                        <h1 className="flex items-center gap-2 text-xl font-semibold text-gray-900 dark:text-gray-100">
                            {titleIcon}
                            {title}
                        </h1>
                        {subtitle ? <p className="text-sm text-gray-500 dark:text-gray-400">{subtitle}</p> : null}
                    </div>
                </div>
                <div className="pr-4">
                    {actions}
                </div>
            </div>
        </div>
    );
}

export default FormHeader;
